import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import './DashboardNavbar.css';

function DashboardNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const isLoggedIn = !!currentUser;

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    if (!isMobile && isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [isMobile, isMenuOpen]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // Logout function to remove the current user from the local storage and clean token after logout
  const handleLogout = () => {
    localStorage.removeItem("currentUser");
    localStorage.removeItem("token");
    localStorage.removeItem("currentGroupId"); // clean up
    navigate("/");
  };

  return (
    <header className="d-flex justify-content-between align-items-center p-3 border-bottom bg-white position-relative">
      {/* Left logo */}
      <div className="d-flex align-items-center">
        <div>
          <h4 className="mb-0">FairSplit</h4>
          <small className="text-muted">
            Split bills, not friendships.
          </small>
        </div>
      </div>

      {/* Desktop nav links */}
      <nav className="d-none d-md-flex align-items-center gap-4">
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/dashboard" className="nav-link">Dashboard</Link>
      </nav>

      {/* Mobile hamburger menu */}
      <button className="btn btn-light d-md-none header-hamburger" onClick={toggleMenu}>
        <span className="header-hamburger-icon">☰</span>
      </button>

      {/* Right side - login or dropdown */}
      <div className="d-none d-md-block">
        {isLoggedIn ? (
          <div className="dropdown">
            <button className="btn btn-light dropdown-toggle d-flex align-items-center" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i className="bi bi-person-circle me-2" style={{ fontSize: "1.2rem" }}></i>
              {currentUser.name || "User"}
            </button>
            <ul className="dropdown-menu dropdown-menu-end">
              <li><Link className="dropdown-item" to="/settings">Settings</Link></li>
              <li><hr className="dropdown-divider" /></li>
              <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
            </ul>
          </div>
        ) : (
          <Link to="/login" className="btn btn-outline-primary">Login</Link>
        )}
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && isMobile && (
        <div className="position-absolute top-100 start-0 w-100 bg-white border-bottom shadow-sm" style={{ zIndex: 1000 }}>
          <div className="p-3">
            <nav className="d-flex flex-column gap-3">
              <Link to="/" className="nav-link fw-bold" onClick={() => setIsMenuOpen(false)}>Home</Link>
              <Link to="/dashboard" className="nav-link fw-bold" onClick={() => setIsMenuOpen(false)}>Dashboard</Link>
              <hr />

              {isLoggedIn ? (
                <>
                  <Link to="/settings" className="nav-link" onClick={() => setIsMenuOpen(false)}>Settings</Link>
                  <button className="nav-link text-start border-0 bg-transparent" onClick={() => { handleLogout(); setIsMenuOpen(false); }}>Logout</button>
                </>
              ) : (
                <Link to="/login" className="nav-link" onClick={() => setIsMenuOpen(false)}>Login</Link>
              )}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}

export default DashboardNavbar;
